/* eslint-disable react/jsx-key */
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import StudyListingCard from './StudyListingCard';
import {
  SLBannerHeaderText,
  SLBannerWrapper,
  SLMainBoxContainer,
  SLTextField,
} from './StudyListing.style';
import {
  STCRWrapper,
  StCRGridContainerWithoutBackground,
} from '../shared/Container/Container.styles';
import SearchIcon from '@mui/icons-material/Search';
import { useState, useMemo } from 'react';
import UiHeading from '../shared/Heading';
import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import useApplyV2Theme from '../../lib/hooks/useApplyV2Theme';

interface IStudyListingProps {
  [key: string]: any;
}

const StudyListing: React.FC<IStudyListingProps> = (props) => {
  const [searchValue, setSearchValue] = useState('');

  // Destructure fields from props and sitecoreContext
  const { fields = {} } = props;
  const {
    isSearchBoxVisible,
    searchSectionHeading,
    searchPlaceholderLabel,
    studyEprList = [],
    descriptionWordLimit,
    titleCharacterLimit,
    titleLineLimit,
    descriptionLineLimit,
    gradientBackground,
  } = fields;
  const { isToapplyV2Theme } = useApplyV2Theme();

  // Memoize filtered list
  const filteredStudyEprList = useMemo(() => {
    if (!searchValue) return studyEprList;
    return studyEprList.filter((a: any) =>
      a?.fields?.studyCondition?.fields?.description?.value
        ?.toLowerCase()
        ?.includes(searchValue.toLowerCase())
    );
  }, [searchValue, studyEprList]);

  return (
    <SLMainBoxContainer>
      {isSearchBoxVisible?.value && (
        <SLBannerWrapper gradient={gradientBackground?.value}>
          <STCRWrapper>
            <StCRGridContainerWithoutBackground sx={{ marginBlock: '2rem' }}>
              <Grid container>
                <Grid item xs={12} sx={{ marginBottom: '1rem' }}>
                  {isToapplyV2Theme ? (
                    <UiHeading
                      size="h2"
                      align="left"
                      color="secondary"
                      data-testid="hero-and-search-title"
                    >
                      {searchSectionHeading}
                    </UiHeading>
                  ) : (
                    <SLBannerHeaderText
                      gutterBottom
                      variant="h1"
                      data-testid="hero-and-search-title"
                    >
                      <Text field={props?.fields?.searchSectionHeading}></Text>
                    </SLBannerHeaderText>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <SLTextField
                    variant="standard"
                    margin="none"
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    placeholder={searchPlaceholderLabel?.value}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end" sx={{ border: 'none' }}>
                          <SearchIcon style={{ cursor: 'pointer' }} />
                        </InputAdornment>
                      ),
                      disableUnderline: true,
                    }}
                  />
                </Grid>
              </Grid>
            </StCRGridContainerWithoutBackground>
          </STCRWrapper>
        </SLBannerWrapper>
      )}
      <STCRWrapper>
        <StCRGridContainerWithoutBackground sx={{ marginBlock: '2rem' }}>
          <Grid container rowGap={7} columnSpacing={6}>
            {filteredStudyEprList?.map((a: any, idx: number) => (
              <Grid item xs={12} md={6} lg={4} key={idx}>
                <StudyListingCard
                  {...a}
                  descriptionWordLimit={descriptionWordLimit?.value || 30}
                  titleCharacterLimit={titleCharacterLimit?.value || 30}
                  titleLineLimit={titleLineLimit?.value || 2}
                  descriptionLineLimit={descriptionLineLimit?.value || 3}
                />
              </Grid>
            ))}
          </Grid>
        </StCRGridContainerWithoutBackground>
      </STCRWrapper>
    </SLMainBoxContainer>
  );
};

export default StudyListing;
